import { api } from "@/lib/api";

export type NotificationCategory =
  | "leave"
  | "document"
  | "task"
  | "shift"
  | "schedule"
  | "infraction"
  | "contract"
  | "security"
  | "user"
  | "tablet"
  | "system"
  | "report"
  | "sick_leave"
  | "absence";

export type NotificationItem = {
  id: string;
  type: string;
  category: NotificationCategory | string;
  title: string;
  body: string;
  data: Record<string, unknown>;
  actor_name: string | null;
  actor_avatar: string | null;
  read_at: string | null;
  created_at: string;
};

export type NotificationListResponse = {
  notifications: NotificationItem[];
  unread_count: number;
  total: number;
};

export async function fetchNotifications(params: {
  limit?: number;
  offset?: number;
  unread_only?: boolean;
}): Promise<NotificationListResponse> {
  const q: Record<string, string | number | boolean> = {
    limit: params.limit ?? 20,
    offset: params.offset ?? 0,
  };
  if (params.unread_only) q.unread_only = true;
  const { data } = await api.get<NotificationListResponse>(
    "/api/v1/notifications",
    { params: q }
  );
  return data;
}

export async function fetchUnreadCount(): Promise<number> {
  const { data } = await api.get<{ count: number }>(
    "/api/v1/notifications/unread-count"
  );
  return data.count;
}

export async function markNotificationRead(id: string): Promise<void> {
  await api.post(`/api/v1/notifications/${id}/read`);
}

export async function markAllNotificationsRead(): Promise<number> {
  const { data } = await api.post<{ ok: boolean; count: number }>(
    "/api/v1/notifications/read-all"
  );
  return data.count ?? 0;
}
